module.exports = __webpack_public_path__ + "img/sushi-king-menu-2024-02.a6cb36c2.png";